import { graphql, useStaticQuery } from "gatsby"

const WesternNorwayImages = () => {
  const data = useStaticQuery(graphql`
    query {
      img1: file(relativePath: { eq: "blog/western-norway/img1.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img2: file(relativePath: { eq: "blog/western-norway/img2.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img3: file(relativePath: { eq: "blog/western-norway/img3.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img4: file(relativePath: { eq: "blog/western-norway/img4.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img5: file(relativePath: { eq: "blog/western-norway/img5.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img6: file(relativePath: { eq: "blog/western-norway/img6.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img7: file(relativePath: { eq: "blog/western-norway/img7.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img8: file(relativePath: { eq: "blog/western-norway/img8.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img9: file(relativePath: { eq: "blog/western-norway/img9.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img10: file(relativePath: { eq: "blog/western-norway/img10.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img11: file(relativePath: { eq: "blog/western-norway/img11.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img12: file(relativePath: { eq: "blog/western-norway/img12.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img13: file(relativePath: { eq: "blog/western-norway/img13.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img14: file(relativePath: { eq: "blog/western-norway/img14.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img15: file(relativePath: { eq: "blog/western-norway/img15.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img16: file(relativePath: { eq: "blog/western-norway/img16.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img17: file(relativePath: { eq: "blog/western-norway/img17.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img18: file(relativePath: { eq: "blog/western-norway/img18.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img19: file(relativePath: { eq: "blog/western-norway/img19.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img20: file(relativePath: { eq: "blog/western-norway/img20.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img21: file(relativePath: { eq: "blog/western-norway/img21.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img22: file(relativePath: { eq: "blog/western-norway/img22.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img23: file(relativePath: { eq: "blog/western-norway/img23.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img24: file(relativePath: { eq: "blog/western-norway/img24.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img25: file(relativePath: { eq: "blog/western-norway/img25.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img26: file(relativePath: { eq: "blog/western-norway/img26.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img27: file(relativePath: { eq: "blog/western-norway/img27.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img28: file(relativePath: { eq: "blog/western-norway/img28.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img29: file(relativePath: { eq: "blog/western-norway/img29.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img30: file(relativePath: { eq: "blog/western-norway/img30.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img31: file(relativePath: { eq: "blog/western-norway/img31.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img32: file(relativePath: { eq: "blog/western-norway/img32.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img33: file(relativePath: { eq: "blog/western-norway/img33.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img34: file(relativePath: { eq: "blog/western-norway/img34.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return data
}

export default WesternNorwayImages
